import React, { useState, useEffect } from 'react';
import '../styles/TelegramSettings.css';

const API_BASE = '/api/settings/telegram';

function authHeaders() {
  const token = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}

export default function TelegramSettings() {
  const [status, setStatus] = useState(null);
  const [botToken, setBotToken] = useState('');
  const [chatId, setChatId] = useState('');
  const [domain, setDomain] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    loadStatus();
  }, []);

  async function loadStatus() {
    setLoading(true);
    try {
      const res = await fetch(API_BASE, { headers: authHeaders() });
      const data = await res.json();
      setStatus(data);
      setChatId(data.chatId || '');
      setDomain(data.domain || '');
    } catch (err) {
      setMessage({ type: 'error', text: 'No se pudo cargar la configuración.' });
    } finally {
      setLoading(false);
    }
  }

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    setMessage(null);
    try {
      const res = await fetch(API_BASE, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify({ botToken, chatId, domain })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al guardar');

      if (data.telegram && data.telegram.ok) {
        setMessage({ type: 'success', text: '✅ Guardado y webhook registrado con Telegram.' });
      } else {
        setMessage({
          type: 'warning',
          text: `Guardado, pero Telegram respondió con un error: ${
            data.telegram && data.telegram.description ? data.telegram.description : 'desconocido'
          }`
        });
      }
      setBotToken(''); // clear the field, keep it masked going forward
      loadStatus();
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
    } finally {
      setSaving(false);
    }
  }

  async function handleTest() {
    setMessage(null);
    try {
      const res = await fetch(`${API_BASE}/test`, { method: 'POST', headers: authHeaders() });
      const data = await res.json();
      setMessage(
        data.sent
          ? { type: 'success', text: '✅ Mensaje de prueba enviado — revisa tu grupo de Telegram.' }
          : { type: 'error', text: 'No se pudo enviar. Verifica el token y el chat ID.' }
      );
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
    }
  }

  if (loading) return <div className="tg-settings">Cargando configuración de Telegram…</div>;

  return (
    <div className="tg-settings">
      <h2>Integración con Telegram</h2>
      <p className="tg-hint">
        Configura el bot que envía alertas al equipo. No se necesita acceso al servidor —
        esto guarda todo y registra el webhook con Telegram automáticamente.
      </p>

      {status && (
        <div className={`tg-status-badge ${status.configured ? 'ok' : 'missing'}`}>
          {status.configured
            ? `Conectado (token: ${status.botTokenMasked})`
            : 'No configurado todavía'}
        </div>
      )}

      {message && <div className={`tg-message tg-message-${message.type}`}>{message.text}</div>}

      <form onSubmit={handleSave} className="tg-form">
        <label>
          Bot Token
          <input
            type="password"
            placeholder={status && status.configured ? 'Dejar en blanco para no cambiar' : '8123456:AAExxxxxxxx'}
            value={botToken}
            onChange={(e) => setBotToken(e.target.value)}
          />
          <span className="tg-field-hint">Obtenido de @BotFather al crear el bot.</span>
        </label>

        <label>
          Chat ID
          <input
            type="text"
            placeholder="-100xxxxxxxxx"
            value={chatId}
            onChange={(e) => setChatId(e.target.value)}
            required
          />
          <span className="tg-field-hint">
            El ID del grupo de Telegram donde llegan las alertas (número negativo).
          </span>
        </label>

        <label>
          Dominio público
          <input
            type="text"
            placeholder="cal.tudominio.com"
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            required
          />
          <span className="tg-field-hint">
            El dominio donde vive este panel — se usa para registrar el webhook.
          </span>
        </label>

        <div className="tg-actions">
          <button type="submit" disabled={saving}>
            {saving ? 'Guardando…' : 'Guardar y registrar webhook'}
          </button>
          {status && status.configured && (
            <button type="button" onClick={handleTest} className="tg-test-btn">
              Enviar mensaje de prueba
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
